<template>
  <div class="spinner spinner--stretch">
    <div class="rect rect-1"></div>
    <div class="rect rect-2"></div>
    <div class="rect rect-3"></div>
    <div class="rect rect-4"></div>
    <div class="rect rect-5"></div>
  </div>
</template>

<script>
// Pure-CSS "stretch" loading spinner. Original code (no third-party dependency);
// replaces the unlicensed vue-loading-spinner "Stretch" component with an identical
// 5-bar sk-stretchdelay animation.
export default {
  name: 'StretchLoading'
}
</script>

<style scoped>
.spinner--stretch {
  display: inline-block;
  font-size: 10px;
  width: 40px;
  height: 40px;
  text-align: center;
}

.spinner--stretch .rect {
  display: inline-block;
  width: 10%;
  height: 100%;
  background-color: #41b883;
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner--stretch .rect-2 { -webkit-animation-delay: -1.1s; animation-delay: -1.1s; }
.spinner--stretch .rect-3 { -webkit-animation-delay: -1.0s; animation-delay: -1.0s; }
.spinner--stretch .rect-4 { -webkit-animation-delay: -0.9s; animation-delay: -0.9s; }
.spinner--stretch .rect-5 { -webkit-animation-delay: -0.8s; animation-delay: -0.8s; }

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4); }
  20% { -webkit-transform: scaleY(1.0); }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% { transform: scaleY(0.4); -webkit-transform: scaleY(0.4); }
  20% { transform: scaleY(1.0); -webkit-transform: scaleY(1.0); }
}
</style>



// WEBPACK FOOTER //
// StretchLoading.vue?39c630b4